import { observable } from 'mobx'
import Validator from '../validators/RequestConsultationValidate'
import { LABEL } from '../lang'

export default class {
  @observable first_name = null;
  @observable last_name = null;
  @observable email = null;
  @observable phone = null;

  constructor (first_name = '', last_name = '', email = '', phone) {
    this.first_name = new Validator('first_name', LABEL.LBL_USER_FIRST_NAME, first_name)
    this.last_name = new Validator('last_name', LABEL.LBL_USER_LAST_NAME, last_name)
    this.email = new Validator('email', LABEL.LBL_USER_EMAIL, email)
    this.phone = new Validator('phone', LABEL.LBL_USER_PHONE, phone)
  }

  resetInputs () {
    this.first_name = new Validator('first_name', LABEL.LBL_USER_FIRST_NAME, '')
    this.last_name = new Validator('last_name', LABEL.LBL_USER_LAST_NAME, '')
    this.email = new Validator('email', LABEL.LBL_USER_EMAIL, '')
    this.phone = new Validator('phone', LABEL.LBL_USER_PHONE, '')
  }

  getParams () {
    return {
      'first_name': this.first_name.value.trim(),
      'last_name': this.last_name.value.trim(),
      'email': this.email.value.trim(),
      'phone': this.phone.value.trim()
    }
  }

  update (key_name, value) {
    this[key_name].value = value
    this[key_name].validate()
  }

  validate () {
    let isValid = true
    for (const key in this) {
      this[key].validate()
      if (this[key].errors.length) {
        isValid = false
      }
    }
    return isValid
  }
}
